import type { ReleasePoint } from "@insights/contracts";

export function getReleaseNotesSelection(
  points: ReleasePoint[],
  selectedFromPointId: string | undefined,
  selectedToPointId: string | undefined,
) {
  const effectiveToPointId = points.some(
    (point) => point.id === selectedToPointId,
  )
    ? selectedToPointId
    : points[0]?.id;
  const toPointIndex = points.findIndex(
    (point) => point.id === effectiveToPointId,
  );
  const fromPoints = points.filter(
    (point, index) => point.kind === "tag" && index > toPointIndex,
  );
  const effectiveFromPointId = fromPoints.some(
    (point) => point.id === selectedFromPointId,
  )
    ? selectedFromPointId
    : fromPoints[0]?.id;

  return { effectiveFromPointId, effectiveToPointId, fromPoints };
}
